var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAerosol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7334 23.92H22.8934C22.431 23.9196 21.9731 24.0104 21.5459 24.1872C21.1187 24.364 20.7305 24.6232 20.4036 24.9502C20.0766 25.2771 19.8174 25.6653 19.6406 26.0925C19.4638 26.5197 19.373 26.9776 19.3734 27.44V49.9733C19.3734 50.3835 19.5363 50.7769 19.8264 51.067C20.1164 51.357 20.5098 51.52 20.92 51.52H32.7334C33.1436 51.52 33.5369 51.357 33.827 51.067C34.1171 50.7769 34.28 50.3835 34.28 49.9733V27.44C34.2804 26.9776 34.1895 26.5197 34.0128 26.0925C33.836 25.6653 33.5767 25.2771 33.2498 24.9502C32.9229 24.6232 32.5347 24.364 32.1075 24.1872C31.6803 24.0104 31.2224 23.9196 30.76 23.92H30.7334Z",
    fill: "#123660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0934 22.3733C31.7424 21.3591 31.1029 20.4693 30.2534 19.8133V18.96H28.68V17.0933H24.92V18.96H23.3467V19.8133C22.5073 20.479 21.8702 21.3656 21.5067 22.3733H20.8934V23.2533H32.6534V22.3733H32.04H32.0934Z",
    fill: "#123660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3867 13.6533L30.8134 17.68V18.4533L44.3867 22.5067V13.6533Z",
    fill: "#123660"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 4.00093C16.5348 4.00093 3.99991 16.5376 3.99991 31.9998C3.99991 47.462 16.5348 59.9987 32 59.9987C47.4653 59.9987 60.0001 47.462 60.0001 31.9998C60.0001 16.5376 47.4653 4.00093 32 4.00093ZM0.000152588 31.9998C0.000152588 14.3249 14.3282 -0.00134277 32 -0.00134277C49.6719 -0.00134277 63.9999 14.3249 63.9999 31.9998C63.9999 49.6747 49.6719 64.0009 32 64.0009C14.3282 64.0009 0.000152588 49.6747 0.000152588 31.9998Z",
    fill: "#FF0033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1153 55.6377L8.03796 11.2857L10.8741 8.46356L54.9515 52.8155L52.1153 55.6377Z",
    fill: "#FF0033"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_85"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAerosol);
export default __webpack_public_path__ + "static/media/icon-aerosol.0c241e44406f862fd92833d3330b349f.svg";
export { ForwardRef as ReactComponent };